import { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import Grid from "@mui/material/Grid2";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Stack,
  TextField,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import {
  createSalesOrder,
  getCustomer,
  getCustomermasterByCode,
  getProductCode,
  getSalesorderById,
  productCodeOption,
  salesOrderState,
  salesOrderStateMange,
  soTypeOption,
  todayallCustomerDropdown,
  todayCustomersDropdown,
  todayDateProducts,
  todayDateProductsDropdown,
  updateSalesOrder,
} from "../salesOrderData/salesOrderData";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";

import MaterialButton from "../../../../components/MaterialButton";
import { TbPencilPlus, TbTrash } from "react-icons/tb";
import { useLoading } from "../../../../context/LodingContext";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";

const SalesOrderForm = () => {
  const [salesOrderData, dispatch] = useReducer(
    salesOrderStateMange,
    salesOrderState
  );

  const [inputDisble, setInputDisble] = useState(false);
  const [customerOption, setCustomerOption] = useState([]);

  const [customerLoading, setCustomerLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [productOption, setProductOption] = useState([]);
  const [productSetInitialized, setProductSetInitialized] = useState(true);
  const { setCirleLoading } = useLoading();

  const { userId } = useAuthData();

  const navigate = useNavigate();
  const location = useLocation();
  const formType = location?.state?.type;
  const rowID = location?.state?.data?.id;

  useEffect(() => {
    fetchTodatCustomer();
    fetchTodayProduct();
  }, []);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
      setProductSetInitialized(false);
    } else if (formType == "edit") {
      setInputDisble(true);
      setProductSetInitialized(true);
    } else {
      setInputDisble(false);
      setProductSetInitialized(true);
    }
  }, [formType]);

  useEffect(() => {
    if (rowID) {
      fetchBySalesOrder();
    }
  }, [rowID]);

  const fetchBySalesOrder = async () => {
    try {
      const res = await request(BASEURL, getSalesorderById, {
        id: Number(rowID),
      });

      const data = res?.getSalesorder?.data[0];
      const selectedCustomerAddress =
        res?.getSalesorder?.selectedCustomerAddress;
      console.log(data, "data");

      const custName = data?.customer?.customerName || "";
      const custCode = data?.customer?.customerCode || "";
      dispatch({
        value: {
          value: data?.customer?.id,
          label: custName && custCode ? `${custName} (${custCode})` : custName,
          customerCode: custCode,
        },
        name: "customerName",
      });
      dispatch({
        value: {
          value: data?.orderType,
          label: data?.orderType,
        },
        name: "soType",
      });
      dispatch({
        value: data?.orderDate,
        name: "orderDate",
      });
      dispatch({
        value: data?.soNumber,
        name: "salesOrderId",
      });
      dispatch({
        value: data?.termsAndConditions,
        name: "terms",
      });
      dispatch({
        value: data?.totalAmount,
        name: "totalAmount",
      });
      dispatch({
        value:
          data?.discount !== undefined &&
            data?.discount !== null &&
            data?.discount !== ""
            ? Number(data?.discount).toFixed(2)
            : data?.discount,
        name: "discount",
      });
      dispatch({
        value: data?.grandTotal,
        name: "grandTotal",
      });
      dispatch({
        value: data?.customerAddress || "",
        name: "customerAddress",
      });

      const updatedProductDetails = data?.salesorderproductSet?.map(
        (product) => {
          const productCode = product?.product?.productCode;
          const productName = product?.product?.productName;
          const label =
            productName && productCode
              ? `${productName} (${productCode})`
              : productName || "";

          return {
            id: product?.id,
            itemName: {
              value: productCode,
              label: label,
              id: product?.product?.id,
            },
            calucualtedPrice: product?.price,
            originalproductPrice: product?.price,
            basePriceCodeAmount: product?.price,
            uomType: { value: product?.uomType, label: product?.uomType },
            qty: product?.quantity,
            priceCode: {
              value: product?.priceCode,
              label: product?.priceCode,
            },
            productPrice: product?.amount,
            taxPercentage: Number(product?.tax),
            taxAmount:
              product?.taxAmount !== undefined &&
                product?.taxAmount !== null &&
                product?.taxAmount !== ""
                ? Number(product?.taxAmount).toFixed(2)
                : "",
            amount:
              product?.totalAmount !== undefined &&
                product?.totalAmount !== null &&
                product?.totalAmount !== ""
                ? Number(product?.totalAmount).toFixed(2)
                : "",

            itemNameStatus: "success",
            qtyStatus: "success",
            priceCodeStatus: "success",
            productPriceStatus: "success",
            taxPercentageStatus: "success",
            taxAmountStatus: "success",
            amountStatus: "success",
            uomTypeStatus: "success",
            calucualtedPriceStatus: "success",
          };
        }
      );

      dispatch({
        value: updatedProductDetails,
        name: "allProduct",
      });
    } catch (error) { }
  };

  useEffect(() => {
    if (!productSetInitialized) return;

    const totalAmount = salesOrderData?.productDetails?.reduce((acc, cur) => {
      return acc + Number(cur?.amount || 0);
    }, 0);

    const totalProductAmount = salesOrderData?.productDetails?.reduce(
      (acc, cur) => acc + Number(cur?.productPrice || 0),
      0
    );

    const vatAmount = salesOrderData?.productDetails?.reduce(
      (acc, cur) => acc + Number(cur?.taxAmount || 0),
      0
    );

    dispatch({ value: Number(totalAmount).toFixed(2), name: "totalAmount" });
    dispatch({ value: Number(totalProductAmount).toFixed(2), name: "grandTotal" });
    dispatch({ value: Number(vatAmount).toFixed(2), name: "discount" });
  }, [salesOrderData?.productDetails, productSetInitialized]);

  const fetchTodatCustomer = () => {
    setCustomerLoading(true);
    request(BASEURL, todayCustomersDropdown)
      .then(async (res) => {
        const success = await res?.todayCustomersDropdown?.success;
        const data = await res?.todayCustomersDropdown?.data;

        if (success) {
          setCustomerOption(data);
        } else {
          setCustomerOption([]);
        }
      })
      .finally(() => {
        setCustomerLoading(false);
      });
  };

  const fetchTodayProduct = () => {
    setProductLoading(true);
    request(BASEURL, todayDateProductsDropdown)
      .then((res) => {
        setProductOption(res?.todayDateProductsDropdown?.data);
      })
      .finally(() => {
        setProductLoading(false);
      });
  };

  useEffect(() => {
    if (productOption?.length && salesOrderData?.productDetails?.length) {
      const needsUpdate = salesOrderData.productDetails.some((item) => {
        if (!item?.itemName) return false;
        const matched = productOption.find(
          (p) =>
            (item.itemName?.id && String(p?.id) === String(item.itemName.id)) ||
            (item.itemName?.value && String(p?.productCode) === String(item.itemName.value))
        );
        if (!matched?.productCode || !matched?.productName) return false;
        const expectedLabel = `${matched.productName} (${matched.productCode})`;
        return item.itemName?.label !== expectedLabel;
      });

      if (needsUpdate) {
        const updated = salesOrderData.productDetails.map((item) => {
          if (!item?.itemName) return item;
          const matched = productOption.find(
            (p) =>
              (item.itemName?.id && String(p?.id) === String(item.itemName.id)) ||
              (item.itemName?.value && String(p?.productCode) === String(item.itemName.value))
          );
          if (!matched?.productCode || !matched?.productName) return item;
          const expectedLabel = `${matched.productName} (${matched.productCode})`;
          return {
            ...item,
            itemName: {
              ...item.itemName,
              value: item.itemName.value || matched.productCode,
              label: expectedLabel,
              id: item.itemName.id || matched.id,
            },
          };
        });
        dispatch({ value: updated, name: "allProduct" });
      }
    }
  }, [productOption]);

  const handleAddNewForm = () => {
    dispatch({ type: "add" });
  };

  const handlePriceCodeChange = (e, s, i) => {
    dispatch({ value: e, name: s?.name, index: i });
  };

  const handleSelectCustomer = async (e, s) => {
    if (e) {
      dispatch({ value: "", name: "customerAddress" });
      try {
        const res = await request(BASEURL, getCustomer, { id: e?.value });

        const customerCoderes = await request(
          BASEURL,
          getCustomermasterByCode,
          {
            code: e?.customerCode,
          }
        );

        const customerData = customerCoderes?.getCustomermasterByCode?.data;
        const addressData = Array.isArray(customerData)
          ? customerData[0]?.addresses || []
          : customerData?.addresses || [];
        dispatch({
          value: addressData[0]?.address || "",
          name: "customerAddress",
        });

        const success = res?.getCustomer?.success;
        const data = res?.getCustomer?.customers[0]?.priceCode;
        dispatch({
          value: { value: data, label: data },
          allPricecode: true,
        });
      } catch (err) { }
    }
    dispatch({ value: e, name: s?.name });
  };

  const handleProductChange = async (e, s, i) => {
    if (e) {
      try {
        const res = await request(BASEURL, getProductCode, {
          productocde: e?.value.trim(),
        });
        const data = res?.getProductCode?.data;
        const productInfo = data?.[0];

        if (!productInfo) return;

        const newOption = [];
        if (productInfo?.productUom) {
          newOption.push({
            value: "productUom",
            label: productInfo?.productUom,
          });
        }
        if (productInfo?.baseUom) {
          newOption.push({
            value: "baseUom",
            label: productInfo?.baseUom,
          });
        }

        const defaultUom =
          newOption.find(
            (opt) => opt?.label?.trim()?.toUpperCase() === "CTN"
          ) ||
          newOption.find((opt) => opt?.value === "productUom") ||
          newOption[0];

        // Use conversion from the dropdown option (todayDateProductsDropdown) if available,
        // otherwise fall back to getProductCode API conversion
        const dropdownConversion = e?.productConversion;
        const conversionFromApi = productInfo?.conversion;
        const resolvedConversion = dropdownConversion || conversionFromApi || "1";

        dispatch({
          value: newOption,
          name: "uomTypeOption",
          index: i,
        });
        dispatch({
          value: resolvedConversion,
          name: "conversation",
          index: i,
        });
        dispatch({
          value: productInfo?.vat || "0",
          name: "taxPercentage",
          index: i,
        });
        dispatch({
          value: e?.stockInCtn !== undefined && e?.stockInCtn !== null ? e.stockInCtn : 0,
          name: "stockInCtn",
          index: i,
        });
        dispatch({
          value: e?.stockInPart !== undefined && e?.stockInPart !== null ? e.stockInPart : 0,
          name: "stockInPart",
          index: i,
        });

        const priceCodeObj =
          salesOrderData?.productDetails[i]?.priceCode ||
          salesOrderData?.selectPriceCode;
        const priceCodeStr =
          typeof priceCodeObj === "object"
            ? priceCodeObj?.label || priceCodeObj?.value || ""
            : String(priceCodeObj || "");
        const priceCodeKey = priceCodeStr.toLowerCase().trim();

        // If priceCode is VANSL: show vansl if > 0, otherwise show csh when vansl is 0
        const effectiveKey =
          priceCodeKey === "vansl"
            ? Number(productInfo?.vansl) > 0
              ? "vansl"
              : "csh"
            : priceCodeKey;

        const baseAmount =
          productInfo?.[effectiveKey] !== undefined &&
            productInfo?.[effectiveKey] !== null
            ? String(productInfo[effectiveKey])
            : "0";

        dispatch({
          value: baseAmount,
          name: "basePriceCodeAmount",
          index: i,
        });

        const isEA =
          defaultUom?.label?.trim()?.toUpperCase() === "EA" ||
          defaultUom?.value === "baseUom";

        let unitPrice = baseAmount;
        const conversionVal = Number(resolvedConversion || 1);

        if (isEA) {
          if (conversionVal > 0) {
            const divResult = Number(baseAmount) / conversionVal;
            unitPrice = Number.isInteger(divResult)
              ? String(divResult)
              : String(parseFloat(divResult.toFixed(4)));
          }
        } else {
          unitPrice = baseAmount;
        }

        dispatch({
          value: defaultUom,
          name: "uomType",
          index: i,
        });
        dispatch({
          value: unitPrice,
          name: "calucualtedPrice",
          index: i,
        });
        dispatch({
          value: unitPrice,
          name: "originalproductPrice",
          index: i,
        });

        const currentQty = salesOrderData?.productDetails[i]?.qty;
        if (currentQty && Number(currentQty) > 0) {
          const total = Number(currentQty) * Number(unitPrice);
          const taxPct = Number(productInfo?.vat || 0);
          const taxAmount = Number(((taxPct / 100) * total).toFixed(2));
          const newTotal = Number((total + taxAmount).toFixed(2));

          dispatch({
            value: total,
            name: "totalAmountProduct",
            index: i,
          });
          dispatch({
            value: total,
            name: "productPrice",
            index: i,
          });
          dispatch({
            value: taxAmount.toFixed(2),
            name: "taxAmount",
            index: i,
          });
          dispatch({
            value: newTotal.toFixed(2),
            name: "amount",
            index: i,
          });
        }
      } catch (err) { }
    } else if (!e) {
      dispatch({
        value: "",
        name: "originalproductPrice",
        index: i,
      });
      dispatch({
        value: "",
        name: "calucualtedPrice",
        index: i,
      });
      dispatch({
        value: "",
        name: "qty",
        index: i,
      });
      dispatch({
        value: "",
        name: "taxPercentage",
        index: i,
      });
      dispatch({
        value: "",
        name: "amount",
        index: i,
      });
      dispatch({
        value: "",
        name: "taxAmount",
        index: i,
      });
      dispatch({
        value: "",
        name: "uomType",
        index: i,
      });
      dispatch({
        value: "",
        name: "productPrice",
        index: i,
      });
      dispatch({
        value: [],
        name: "uomTypeOption",
        index: i,
      });
      dispatch({
        value: "",
        name: "basePriceCodeAmount",
        index: i,
      });
      dispatch({
        value: "",
        name: "stockInCtn",
        index: i,
      });
      dispatch({
        value: "",
        name: "stockInPart",
        index: i,
      });
    }

    dispatch({ value: e, name: s?.name, index: i });
  };

  const handleQuanityChange = (e, i) => {
    const value = e?.target?.value;

    const total =
      Number(value) *
      Number(salesOrderData?.productDetails[i]?.originalproductPrice);
    const totalPercentage =
      Number(salesOrderData?.productDetails[i]?.taxPercentage) * Number(value);
    const percentageAmount = Number(
      (
        (Number(salesOrderData?.productDetails[i]?.taxPercentage) / 100) *
        Number(total)
      ).toFixed(2)
    );

    const newTotal = Number((Number(total || 0) + percentageAmount).toFixed(2));
    if (value) {
      dispatch({
        value: value,
        name: "qty",
        index: i,
      });
      dispatch({
        value: percentageAmount.toFixed(2),
        name: "taxAmount",
        index: i,
      });

      dispatch({
        value: total,
        name: "totalAmountProduct",
        index: i,
      });
      dispatch({
        value: newTotal.toFixed(2),
        name: "amount",
        index: i,
      });
      dispatch({
        value: total,
        name: "productPrice",
        index: i,
      });
    } else {
      dispatch({
        value: "",
        name: "qty",
        index: i,
      });
      dispatch({
        value: "",
        name: "taxAmount",
        index: i,
      });
      dispatch({
        value: "",
        name: "totalAmountProduct",
        index: i,
      });
      dispatch({
        value: "",
        name: "amount",
        index: i,
      });
      dispatch({
        value: "",
        name: "productPrice",
        index: i,
      });
    }
  };

  const handlePriceChange = (e, i) => {
    const newPrice = e?.target?.value;

    // Update the displayed price and the base price
    dispatch({
      value: newPrice,
      name: "calucualtedPrice",
      index: i,
    });
    dispatch({
      value: newPrice,
      name: "originalproductPrice",
      index: i,
    });

    const currentQty = Number(salesOrderData?.productDetails[i]?.qty || 0);
    const taxPct = Number(salesOrderData?.productDetails[i]?.taxPercentage || 0);

    if (newPrice && currentQty > 0) {
      const total = Number(newPrice) * currentQty;
      const taxAmount = Number(((taxPct / 100) * total).toFixed(2));
      const newTotal = Number((total + taxAmount).toFixed(2));

      dispatch({ value: total, name: "totalAmountProduct", index: i });
      dispatch({ value: total, name: "productPrice", index: i });
      dispatch({ value: taxAmount.toFixed(2), name: "taxAmount", index: i });
      dispatch({ value: newTotal.toFixed(2), name: "amount", index: i });
    } else {
      dispatch({ value: "", name: "totalAmountProduct", index: i });
      dispatch({ value: "", name: "productPrice", index: i });
      dispatch({ value: "", name: "taxAmount", index: i });
      dispatch({ value: "", name: "amount", index: i });
    }
  };

  const handleTaxChange = (e, i) => {
    const value = e?.target?.value;
    const taxamount = Number(
      (
        (Number(value) / 100) *
        Number(salesOrderData?.productDetails[i]?.productPrice)
      ).toFixed(2)
    );
    const amount = Number(
      (
        taxamount +
        Number(salesOrderData?.productDetails[i]?.totalAmountProduct)
      ).toFixed(2)
    );
    dispatch({
      value: value,
      name: "taxPercentage",
      index: i,
    });
    dispatch({
      value: taxamount.toFixed(2),
      name: "taxAmount",
      index: i,
    });
    dispatch({
      value: amount.toFixed(2),
      name: "amount",
      index: i,
    });
  };

  const handleDiscountChange = (e) => {
    const value = e?.target?.value;
    dispatch({
      value: value,
      name: "discount",
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    const isAllSuccess = salesOrderData?.productDetails?.every(
      (item) =>
        item.itemNameStatus === "success" &&
        item.qtyStatus === "success" &&
        item.priceCodeStatus === "success" &&
        item.productPriceStatus === "success" &&
        item.taxPercentageStatus === "success" &&
        item.taxAmountStatus === "success" &&
        item.amountStatus === "success"
    );

    if (
      isAllSuccess &&
      salesOrderData.soTypeStatus === "success" &&
      salesOrderData.orderDateStatus === "success" &&
      salesOrderData.customerNameStatus === "success" &&
      salesOrderData.customerAddressStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAdd = async () => {
    setCirleLoading(true);

    const renamedProductDetails = salesOrderData?.productDetails?.map(
      (item) => ({
        product: Number(item?.itemName?.id),
        uomType: item?.uomType?.label,
        quantity: item?.qty,
        priceCode: item?.priceCode?.label,
        amount: String(item?.productPrice),
        tax: item?.taxPercentage,
        totalAmount: String(item?.amount),
        price: String(item?.calucualtedPrice),
        taxAmount: String(item?.taxAmount),
      })
    );

    try {
      const res = await request(BASEURL, createSalesOrder, {
        input: {
          user: userId,
          // sio: salesOrderData?.salesOrderId,
          customer: Number(salesOrderData?.customerName?.value),
          orderType: salesOrderData?.soType?.label,
          orderDate: salesOrderData?.orderDate,
          termsAndConditions: salesOrderData?.terms,
          discount: String(salesOrderData?.discount),
          totalAmount: String(salesOrderData?.totalAmount),
          status: "Pending",
          customerAddress: salesOrderData?.customerAddress,
          grandTotal: String(salesOrderData?.grandTotal),
          products: renamedProductDetails,
        },
      });

      const success = res?.createSalesOrder?.success;
      const message = res?.createSalesOrder?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/sales-order");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdate = async () => {
    setCirleLoading(true);
    const renamedProductDetails = salesOrderData?.productDetails?.map(
      (item) => ({
        id: item?.id,
        product: Number(item?.itemName?.id),
        uomType: item?.uomType?.label,
        quantity: item?.qty,
        priceCode: item?.priceCode?.label,
        amount: String(item?.productPrice),
        tax: item?.taxPercentage,
        totalAmount: String(item?.amount),
        price: String(item?.calucualtedPrice),
        taxAmount: String(item?.taxAmount),
      })
    );

    try {
      const res = await request(BASEURL, updateSalesOrder, {
        input: {
          // user: userId,
          salesOrderId: rowID,
          sio: salesOrderData?.salesOrderId,
          customer: Number(salesOrderData?.customerName?.value),
          orderType: salesOrderData?.soType?.label,
          orderDate: salesOrderData?.orderDate,
          teamsAndConditions: salesOrderData?.terms,
          discount: String(salesOrderData?.discount),
          totalAmount: String(salesOrderData?.totalAmount),
          status: "Pending",
          customerAddress: salesOrderData?.customerAddress,
          grandTotal: String(salesOrderData?.grandTotal),
          products: renamedProductDetails,
        },
      });

      const success = res?.updateSalesOrder?.success;
      const message = res?.updateSalesOrder?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/sales-order");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUomChange = (e, s, i) => {
    if (e) {
      const currentItem = salesOrderData?.productDetails[i];
      const basePrice =
        currentItem?.basePriceCodeAmount !== undefined &&
          currentItem?.basePriceCodeAmount !== ""
          ? currentItem?.basePriceCodeAmount
          : currentItem?.calucualtedPrice;

      const conversionVal = Number(currentItem?.conversation || 1);

      const isEA =
        e?.label?.trim()?.toUpperCase() === "EA" ||
        e?.value === "baseUom";

      let finalUnitPrice = basePrice;

      if (isEA) {
        if (conversionVal > 0) {
          const divResult = Number(basePrice) / conversionVal;
          finalUnitPrice = Number.isInteger(divResult)
            ? String(divResult)
            : String(parseFloat(divResult.toFixed(4)));
        }
      } else {
        finalUnitPrice = basePrice;
      }

      dispatch({
        value: finalUnitPrice,
        name: "calucualtedPrice",
        index: i,
      });
      dispatch({
        value: finalUnitPrice,
        name: "originalproductPrice",
        index: i,
      });

      const qty = currentItem?.qty;
      if (qty && Number(qty) > 0) {
        const total = Number(qty) * Number(finalUnitPrice);
        const taxPercentage = Number(currentItem?.taxPercentage || 0);
        const taxAmount = Number(((taxPercentage / 100) * total).toFixed(2));
        const newTotal = Number((total + taxAmount).toFixed(2));

        dispatch({
          value: total,
          name: "totalAmountProduct",
          index: i,
        });
        dispatch({
          value: total,
          name: "productPrice",
          index: i,
        });
        dispatch({
          value: taxAmount.toFixed(2),
          name: "taxAmount",
          index: i,
        });
        dispatch({
          value: newTotal.toFixed(2),
          name: "amount",
          index: i,
        });
      } else {
        dispatch({
          value: "",
          name: "qty",
          index: i,
        });
        dispatch({
          value: "",
          name: "totalAmountProduct",
          index: i,
        });
        dispatch({
          value: "",
          name: "productPrice",
          index: i,
        });
        dispatch({
          value: "",
          name: "taxAmount",
          index: i,
        });
        dispatch({
          value: "",
          name: "amount",
          index: i,
        });
      }
    } else {
      dispatch({
        value: "",
        name: "uomType",
        index: i,
      });
      dispatch({
        value: "",
        name: "qty",
        index: i,
      });
      dispatch({
        value: "",
        name: "totalAmountProduct",
        index: i,
      });
      dispatch({
        value: "",
        name: "amount",
        index: i,
      });
      dispatch({
        value: "",
        name: "productPrice",
        index: i,
      });
      dispatch({
        value: "",
        name: "taxAmount",
        index: i,
      });
      const basePrice = salesOrderData?.productDetails[i]?.basePriceCodeAmount || "";
      dispatch({
        value: basePrice,
        name: "calucualtedPrice",
        index: i,
      });
      dispatch({
        value: basePrice,
        name: "originalproductPrice",
        index: i,
      });
    }
    dispatch({ value: e, name: s?.name, index: i });
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Sales Order Details"
                    : formType == "edit"
                      ? "Edit Sales Order Details"
                      : "View Sales Order Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              {inputDisble && (
                <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Sales Order Id <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    value={salesOrderData?.salesOrderId}
                    name="salesOrderId"
                    disabled
                    onChange={(e) =>
                      dispatch({
                        value: e?.target?.value,
                        name: "salesOrderId",
                      })
                    }
                    error={
                      salesOrderData.salesOrderIdStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      salesOrderData.salesOrderIdStatus === "success"
                        ? true
                        : false
                    }
                  />
                </Grid>
              )}
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="customerName"
                  value={salesOrderData?.customerName}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={customerOption?.map((item) => {
                    const name = item?.customerName || "";
                    const code = item?.customerCode || "";
                    return {
                      value: item?.id,
                      label: name && code ? `${name} (${code})` : name,
                      customerCode: code,
                    };
                  })}
                  onChange={(e, s) => handleSelectCustomer(e, s)}
                  error={
                    salesOrderData.customerNameStatus === "error" ? true : false
                  }
                  success={
                    salesOrderData.customerNameStatus === "success"
                      ? true
                      : false
                  }
                  isLoading={customerLoading}
                  isClearable
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Sales Order Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="soType"
                  value={salesOrderData?.soType}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={soTypeOption?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  error={salesOrderData.soTypeStatus === "error" ? true : false}
                  success={
                    salesOrderData.soTypeStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Order Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="date"
                  value={salesOrderData?.orderDate}
                  name="orderDate"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "orderDate" })
                  }
                  error={
                    salesOrderData.orderDateStatus === "error" ? true : false
                  }
                  success={
                    salesOrderData.orderDateStatus === "success" ? true : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 12, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Address<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                {/* <MaterialSelect
                 
                    multiline
                  rows={4}
                  value={salesOrderData?.customerAddress}
                  name="customerAddress"
                  isDisabled={inputDisble}
                  options={addressOptions}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  error={
                    salesOrderData.customerAddressStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    salesOrderData.customerAddressStatus === "success"
                      ? true
                      : false
                  }
                /> */}
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  maxRows={5}
                  value={salesOrderData?.customerAddress || ""}
                  name="customerAddress"
                  disabled={inputDisble}
                  onChange={(event) =>
                    dispatch({
                      value: event.target.value,
                      name: "customerAddress",
                    })
                  }
                  error={
                    salesOrderData.customerAddressStatus === "error" ? true : false
                  }
                  success={
                    salesOrderData.customerAddressStatus === "success" ? true : false
                  }
                  helperText={
                    salesOrderData.customerAddressStatus === "error"
                      ? "Please enter a valid address."
                      : ""
                  }
                  placeholder="Enter customer address"
                  size="small"
                />
              </Grid>
            </Grid>
            <Box sx={{ margin: "30px 0px" }}>
              {salesOrderData?.productDetails?.map((val, i) => {
                const matchedProduct = productOption?.find(
                  (p) =>
                    (val?.itemName?.id && String(p?.id) === String(val.itemName.id)) ||
                    (val?.itemName?.value && String(p?.productCode) === String(val.itemName.value))
                );
                const stockInCtn =
                  val?.stockInCtn !== undefined && val?.stockInCtn !== ""
                    ? val.stockInCtn
                    : val?.itemName?.stockInCtn !== undefined
                      ? val.itemName.stockInCtn
                      : matchedProduct?.stockInCtn;

                const stockInPart =
                  val?.stockInPart !== undefined && val?.stockInPart !== ""
                    ? val.stockInPart
                    : val?.itemName?.stockInPart !== undefined
                      ? val.itemName.stockInPart
                      : matchedProduct?.stockInPart;

                return (
                  <Box
                    key={i}
                    sx={{
                      border: "solid 1px",
                      padding: "10px",
                      borderRadius: "10px",
                      margin: "30px 0px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid size={{ lg: 12, xs: 5, sm: 3 }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Box sx={{ width: "90%" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                gap: 1,
                                mb: 0.5,
                              }}
                            >
                              <MaterialBox lineHeight={0} display="inline-block">
                                <MaterialTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                >
                                  Item Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </MaterialTypography>
                              </MaterialBox>
                              {val?.itemName && (
                                <Stack direction="row" spacing={1} alignItems="center">
                                  <Chip
                                    label={
                                      <span>
                                        Current Stock In CTN:{" "}
                                        <b>{stockInCtn !== undefined && stockInCtn !== null ? stockInCtn : 0}</b>
                                      </span>
                                    }
                                    size="small"
                                    sx={{
                                      backgroundColor: "#e8f5e9",
                                      color: "#2e7d32",
                                      fontWeight: 600,
                                      fontSize: "12px",
                                      height: "24px",
                                      borderRadius: "6px",
                                      border: "1px solid #a5d6a7",
                                    }}
                                  />
                                  <Chip
                                    label={
                                      <span>
                                        Current Stock In EA:{" "}
                                        <b>{stockInPart !== undefined && stockInPart !== null ? stockInPart : 0}</b>
                                      </span>
                                    }
                                    size="small"
                                    sx={{
                                      backgroundColor: "#e3f2fd",
                                      color: "#1565c0",
                                      fontWeight: 600,
                                      fontSize: "12px",
                                      height: "24px",
                                      borderRadius: "6px",
                                      border: "1px solid #90caf9",
                                    }}
                                  />
                                </Stack>
                              )}
                            </Box>
                            <MaterialSelect
                              name="itemName"
                              value={val?.itemName}
                              customStyles={{ optionPadding: 20 }}
                              isDisabled={
                                inputDisble
                                  ? true
                                  : salesOrderData?.customerName
                                    ? false
                                    : true
                              }
                              options={productOption?.map((item) => {
                                return {
                                  value: item?.productCode,
                                  label: item?.productName + ' (' + item?.productCode + ')',
                                  id: item?.id,
                                  productConversion: item?.conversion,
                                  stockInPart: item?.stockInPart,
                                  stockInCtn: item?.stockInCtn,
                                };
                              })}
                              onChange={(e, s) => handleProductChange(e, s, i)}
                              error={
                                val.itemNameStatus === "error" ? true : false
                              }
                              success={
                                val.itemNameStatus === "success" ? true : false
                              }
                              isLoading={productLoading}
                              isClearable
                            />
                          </Box>
                          {!inputDisble && (
                            <Box
                              sx={{
                                width: "10%",
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "10px",
                                marginTop: "25px",
                              }}
                            >
                              <TbPencilPlus
                                style={{
                                  fontSize: "45px",
                                  color: "white",
                                  fontWeight: "600",
                                  padding: "5px 10px",
                                  borderRadius: "50%",
                                  backgroundColor: "#2a9941",
                                }}
                                onClick={handleAddNewForm}
                              />
                              {i != 0 && (
                                <TbTrash
                                  style={{
                                    fontSize: "45px",
                                    color: "white",
                                    fontWeight: "600",
                                    padding: "5px 10px",
                                    borderRadius: "50%",
                                    backgroundColor: "#ff4d4f",
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    dispatch({ type: "delete", index: i })
                                  }
                                />
                              )}
                            </Box>
                          )}
                        </Box>
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Price Code <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                          name="priceCode"
                          value={val?.priceCode}
                          customStyles={{ optionPadding: 20 }}
                          // isDisabled={
                          //   inputDisble ? true : val?.itemName ? false : true
                          // }
                          isDisabled={true}
                          options={productCodeOption?.map((item) => {
                            return {
                              value: item,
                              label: item,
                            };
                          })}
                          onChange={(e, s) => handlePriceCodeChange(e, s, i)}
                          error={val.priceCodeStatus === "error" ? true : false}
                          success={
                            val.priceCodeStatus === "success" ? true : false
                          }
                          isClearable
                        />
                      </Grid>

                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Price Code Amount{" "}
                            <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          placeholder={
                            val?.itemName
                              ? "Enter Product Price"
                              : "Select Item Name"
                          }
                          value={val?.calucualtedPrice}
                          name="calucualtedPrice"
                          disabled={
                            inputDisble ? true : val?.itemName ? false : true
                          }
                          onChange={(e) => handlePriceChange(e, i)}
                          error={
                            val.calucualtedPriceStatus === "error"
                              ? true
                              : false
                          }
                          success={
                            val.calucualtedPriceStatus === "success"
                              ? true
                              : false
                          }
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            UOM Type <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                          name="uomType"
                          value={val?.uomType}
                          customStyles={{ optionPadding: 20 }}
                          isDisabled={
                            inputDisble
                              ? true
                              : salesOrderData?.customerName
                                ? false
                                : true
                          }
                          options={val?.uomTypeOption?.map((item) => {
                            return {
                              value: item?.value,
                              label: item?.label,
                            };
                          })}
                          onChange={(e, s) => handleUomChange(e, s, i)}
                          error={val.uomTypeStatus === "error" ? true : false}
                          success={
                            val.uomTypeStatus === "success" ? true : false
                          }
                          isLoading={productLoading}
                          isClearable
                        />
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Qtn <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          placeholder={
                            val?.itemName ? "Enter Qtny" : "Select Item Name"
                          }
                          value={val?.qty}
                          name="qty"
                          disabled={
                            inputDisble ? true : val?.itemName ? false : true
                          }
                          onChange={(e) => handleQuanityChange(e, i)}
                          error={val.qtyStatus === "error" ? true : false}
                          success={val.qtyStatus === "success" ? true : false}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>

                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Product Price{" "}
                            <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          placeholder={
                            val?.itemName
                              ? "Enter Product Price"
                              : "Select Item Name"
                          }
                          value={val?.productPrice}
                          name="productPrice"
                          disabled={true}
                          onChange={(e) =>
                            dispatch({
                              value: e?.target?.value,
                              name: "productPrice",
                              index: i,
                            })
                          }
                          error={
                            val.productPriceStatus === "error" ? true : false
                          }
                          success={
                            val.productPriceStatus === "success" ? true : false
                          }
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            VAT Percentage{" "}
                            <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          placeholder={
                            val?.itemName
                              ? "Enter Tax Percentage"
                              : "Select Item Name"
                          }
                          value={val?.taxPercentage}
                          name="taxPercentage"
                          disabled={true}
                          onChange={(e) => handleTaxChange(e, i)}
                          error={
                            val.taxPercentageStatus === "error" ? true : false
                          }
                          success={
                            val.taxPercentageStatus === "success" ? true : false
                          }
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            VAT Amount <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          placeholder={
                            val?.itemName
                              ? "Enter Tax Amount"
                              : "Select Item Name"
                          }
                          value={
                            val?.taxAmount !== "" &&
                              val?.taxAmount !== undefined &&
                              val?.taxAmount !== null
                              ? Number(val?.taxAmount).toFixed(2)
                              : ""
                          }
                          name="taxAmount"
                          disabled={true}
                          onChange={(e) =>
                            dispatch({
                              value: e?.target?.value,
                              name: "taxAmount",
                              index: i,
                            })
                          }
                          error={val.taxAmountStatus === "error" ? true : false}
                          success={
                            val.taxAmountStatus === "success" ? true : false
                          }
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Amount <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          value={
                            val?.amount !== "" &&
                              val?.amount !== undefined &&
                              val?.amount !== null
                              ? Number(val?.amount).toFixed(2)
                              : ""
                          }
                          name="amount"
                          placeholder="Enter Product Code"
                          disabled={true}
                          onChange={(e) =>
                            dispatch({
                              value: e?.target?.value,
                              name: "amount",
                              index: i,
                            })
                          }
                          error={val.amountStatus === "error" ? true : false}
                          success={
                            val.amountStatus === "success" ? true : false
                          }
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                );
              })}
            </Box>
            <Grid container spacing={2}>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Terms and condition
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  multiline
                  rows={4}
                  value={salesOrderData?.terms}
                  name="customerAddress"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "terms" })
                  }
                  error={salesOrderData.termsstatus === "error" ? true : false}
                  success={
                    salesOrderData.termsstatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 9, xs: 5, sm: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "70px",
                  }}
                >
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Grand Total <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                      value={salesOrderData?.grandTotal}
                      name="grandTotal"
                      disabled={true}
                      onChange={(e) =>
                        dispatch({
                          value: e?.target?.value,
                          name: "grandTotal",
                        })
                      }
                      error={
                        salesOrderData.grandTotalStatus === "error"
                          ? true
                          : false
                      }
                      success={
                        salesOrderData.grandTotalStatus === "success"
                          ? true
                          : false
                      }
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      sx={{
                        "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                        "& input": {
                          MozAppearance: "textfield",
                        },
                      }}
                    />
                  </MaterialBox>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Total VAT Amount
                    </MaterialTypography>
                    <MaterialInput
                      type="number"
                      value={
                        salesOrderData?.discount !== "" &&
                          salesOrderData?.discount !== undefined &&
                          salesOrderData?.discount !== null
                          ? Number(salesOrderData?.discount).toFixed(2)
                          : ""
                      }
                      name="discount"
                      disabled={true}
                      onChange={(e) => handleDiscountChange(e)}
                      error={
                        salesOrderData.discountStatus === "error" ? true : false
                      }
                      success={
                        salesOrderData.discountStatus === "success"
                          ? true
                          : false
                      }
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      sx={{
                        "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                        "& input": {
                          MozAppearance: "textfield",
                        },
                      }}
                    />
                  </MaterialBox>

                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Total Amount <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                      value={
                        salesOrderData?.totalAmount !== "" &&
                          salesOrderData?.totalAmount !== undefined &&
                          salesOrderData?.totalAmount !== null
                          ? Number(salesOrderData?.totalAmount).toFixed(2)
                          : ""
                      }
                      name="totalAmount"
                      disabled={true}
                      onChange={(e) =>
                        dispatch({
                          value: e?.target?.value,
                          name: "totalAmount",
                        })
                      }
                      error={
                        salesOrderData.totalAmountStatus === "error"
                          ? true
                          : false
                      }
                      success={
                        salesOrderData.totalAmountStatus === "success"
                          ? true
                          : false
                      }
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      sx={{
                        "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                        "& input": {
                          MozAppearance: "textfield",
                        },
                      }}
                    />
                  </MaterialBox>
                </Box>
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/sales-order")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={formType == "add" ? handleAdd : handleUpdate}
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default SalesOrderForm;
